// @ts-nocheck
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, PopulateApiParameter, props => {
    props.apiParameter = {
        ...props.apiParameter,
        cartLine: {
            ...props.apiParameter.cartLine,
            // Store Custom Code
            properties: { artSelection: props.apiParameter.cartLine.properties.artSelection },
        },
    };
});
